/**
 * Created with IntelliJ IDEA.
 * User: danielr
 * Date: 5/8/13
 * Time: 1:19 PM
 * To change this template use File | Settings | File Templates.
 *
 * This is the backbone collection used to render the SingleSelect Collection View
 */
define(function (require) {
    "use strict";

    var Translator = require("i18n/translator");
    var SingleSelectModel = require('ui/single-select/js/models/SingleSelectModel');
    var BaseCollection = require("collections/BaseCollection");

    var SingleSelectCategoriesCollection = BaseCollection.extend({
        model: SingleSelectModel
    });

    return SingleSelectCategoriesCollection;
});